<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="权限设置">
                <div class="form-group-style permission-list">
                    <div class="permission-list">
                        <el-input placeholder="输入关键字过滤您想搜索的内容" v-model="filterText" class="filter-input"></el-input>
                        <el-tree
                                v-loading="isLoading"
                                :empty-text="empty"
                                :data="data"
                                show-checkbox
                                default-expand-all
                                node-key="id"
                                ref="permissionTree"
                                highlight-current
                                :filter-node-method="filterNode"
                                @check-change="checkChange"
                                :default-checked-keys="default_checked"
                                :props="defaultProps">
                        </el-tree>
                    </div>
                    <div>
                        <el-button type="primary" @click="submitForm()" v-if="typeId==0">保 存</el-button>
                        <el-button type="info"  @click="returnList()" v-if="typeId==0">取 消</el-button>
                        <el-button type="info"  @click="returnList()" v-if="typeId==1">返回</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {getQueryObject} from '@/utils/index'
    import {getPermissionsAssigned, getPermissionsRole, setRolePermissions} from '@/service/user'
    export default {
        name: "Permissions",
        data () {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'name',
                },
                filterText: '',
                data: [],
                dataRoleId:[],
                default_checked : [],
                checked : [],
                arr:[],
                typeId:null,
                user_id:this.$store.state.user.userInfo.id,
                role_id:this.$store.state.user.userInfo.role_id,
                empty:"",
                isLoading: false
            }
        },
        mounted (){
            this.rolePermi()
        },
        watch: {
            filterText (val) {
                this.$refs.permissionTree.filter(val)
            }
        },
        methods: {
            submitForm(){
                let query = getQueryObject()
                if (!query.role_id) {
                    this.$router.push('list')
                }
                let param = {
                    permissions : this.getCheckedNodes()
                }
                setRolePermissions(query.role_id, param).then((data) => {
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                    this.$router.push('list')
                }).catch(err => {
                    this.$message({
                        message: err.message || '修改失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            },
            returnList() {
                this.$router.push('list')
            },
            getChildren(rel, data){
                let i;
                
                  if (data.children && this.typeId==1) {
                      for (i=0;i<data.children.length;i++) {
                          data.children[i].disabled=true;
                          rel = this.getChildren(rel, data.children[i])
                      }
                  }else if(data.children){
                        for (i=0;i<data.children.length;i++) {
                         this.arr.push(data.children[i].id)
                          rel = this.getChildren(rel, data.children[i])
                      }
                  }else {
                       rel.push(data.id)
                  }
                  //console.log(this.arr)
                  return rel;
            },
             getChildren2(rel, data){
                 let _this=this
                 let i;
                  if (data.children && _this.typeId==1) {
                      for (i=0;i<data.children.length;i++) {
                          data.children[i].disabled=true;
                          rel = _this.getChildren2(rel, data.children[i])
                      }
                  }else if(data.children){
                        for (i=0;i<data.children.length;i++) {
                            if(_this.dataRoleId.includes(data.children[i].id)==false){
                                data.children[i].disabled=true;
                            }
                          rel = _this.getChildren2(rel, data.children[i])
                      }
                  }else {
                       rel.push(data.id)
                  }
                  return rel;
            },
            async rolePermi(){
                this.arr=[]
                getPermissionsAssigned(this.role_id).then((data) => {
                    let level1=[];
                    let lowest = []
                    let i;
                    for(i=0;i<data.length;i++){
                        level1.push(data[i].id);
                        lowest = this.getChildren(lowest, data[i])
                    }
                    if(i==data.length){
                        this.dataRoleId = this.arr.concat(level1)
                        this.initData()
                    }
                    
                })

            },
            async initData(){
                 // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                let query = getQueryObject()
                this.typeId=query.type;
                if (!query.role_id) {
                    this.$router.push('list')
                }
              
                await getPermissionsRole(query.role_id).then((data) => {
                    for (let i in data) {
                        this.default_checked.push(data[i].id)
                    }
                })

                getPermissionsAssigned(query.role_id).then((data) => {
                     // 数据请求完毕取消当前页面的loading
                    this.isLoading = false
                    let _this=this;
                    let lowest = []
                    let a 
                    if(this.typeId==1){
                        for (a=0;a<data.length;a++) {
                            data[a].disabled=true;
                            lowest = this.getChildren2(lowest, data[a])
                        }
                    }else{
                         for (a=0;a<data.length;a++) {
                            if(_this.dataRoleId.includes(data[a].id)==false){
                                data[a].disabled=true;
                            }
                            lowest = _this.getChildren2(lowest, data[a])
                        }
                       
                    }
                    
                    _this.default_checked  =  _this.default_checked.filter(v => lowest.includes(v))
                    _this.data = data
                     if(_this.data.length===0){
                       _this.empty="暂无数据"
                   }
                })

            },
            getCheckedNodes() {
                let parentArr = this.$refs.permissionTree.getHalfCheckedKeys()   //获取半选中状态的id
                let childArr = this.$refs.permissionTree.getCheckedKeys()  //获取全选中的id
                this.checked = parentArr.concat(childArr)   //拼接在一起
                return this.checked
            },
            filterNode(value, data) {
                if (!value) return true
                return data.name.indexOf(value) !== -1
            },
            checkChange (a, b, c) {
                //console.log('当前节点对象：', a , '当前节点是否选中', b, '子节点是否选中', c)
            }
        }
    }
</script>
<style lang="less">
    .permission-list{
        .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            &::before{
                box-sizing: content-box;
                content: "";
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                height: 7px;
                left: 4px;
                position: absolute;
                top: 1px;
                transform: rotate(45deg) scaleY(0);
                width: 3px;
                transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
                transform-origin: center;
                transform: rotate(45deg) scaleY(1);
                background: transparent;
            }
        }
    }
</style>
<style scoped>

</style>
